<template>
  <div class="login-container">
    <el-form @submit.prevent="login" :model="form" ref="form" :rules="rules"  class="login-form" auto-complete="on" label-position="left">
      <div class="title-container">
        <img src="@/assets/img/logo.svg" width="300">
        <h3 class="title">Registrarse</h3>
      </div>

      <el-form-item prop="full_name">
        <el-input v-model="form.full_name" placeholder="Apellido y Nombre" type="text"/>
      </el-form-item>

      <el-form-item prop="email">
        <el-input v-model="form.email" placeholder="Email" type="text"/>
      </el-form-item>

      <el-form-item prop="password">
        <el-input v-model="form.password" type="password" placeholder="Contraseña" show-password />
      </el-form-item>

      <el-form-item prop="re_password">
        <el-input v-model="form.re_password" type="password" placeholder="Reingrese Contraseña" show-password />
      </el-form-item>

      <el-button type="primary" style="width:100%;margin-bottom:30px;" @click="registerButtonPressed">Registrarse</el-button>

      <div>
        <span>Si ya tiene una cuenta puede <router-link :to="{ name: 'Login' }">Entrar</router-link></span>
      </div>
    </el-form>
  </div>
</template>

<script>
import firebase from "firebase/app";
export default {
data() {
  var validatePass = (rule, value, callback) => {
    if (value === "" && this.form.password === "") {
      callback(new Error("Debe ingresar una contraseña"));
    } else if (value !== this.form.password) {
      callback(new Error("Las dos contraseñas deben coincidir"));
    } else if (value && value.length < 6) {
      callback(new Error("La contraseña debe tener al menos 6 letras"));
    } else {
      callback();
    }
  };
  return {
    form: {
      full_name: '',
      email: '',
      password: '',
      re_password: '',
    },
    rules: {
      full_name: [
        {
          required: true,
          message: "Debe ingresar un nombre",
          trigger: "blur"
        }
      ],
      email: [
        {
          required: true,
          message: "Debe ingresar un email",
          trigger: "blur"
        }
      ],
      password: [
        {
          required: true,
          message: "Debe ingresar una contraseña",
          trigger: "blur"
        }
      ],
      re_password: [
        {
          required: true,
          validator: validatePass,
          trigger: "blur"
        }
      ],
    },
  };
  },
  methods: {
    async registerButtonPressed() {
      this.$refs['form'].validate( async valid => {
        if (valid) { // Valid form
          try {
            // Create auth user
            var user = await firebase.auth().createUserWithEmailAndPassword(this.form.email, this.form.password)
            .then( (user) => {
              user.user.updateProfile({displayName: this.form.full_name})
            })
            
            firebase.auth().signOut()
            this.$router.replace({name: 'Login'})
          } catch (error) {
              console.error(error.message);
          }
        }
      })
  }
}
}
</script>
<style>
a {
  text-decoration: none;
}

.login-container {
  min-height: 100%;
  width: 100%;
  overflow: hidden;
}
.login-form {
  position: relative;
  width: 420px;
  max-width: 100%;
  padding: 160px 35px 0;
  margin: 0 auto;
  overflow: hidden;
}

</style>